import { render, staticRenderFns } from "./TopicAuthor.vue?vue&type=template&id=a8f456f4&scoped=true"
import script from "./TopicAuthor.vue?vue&type=script&lang=js"
export * from "./TopicAuthor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f456f4",
  null
  
)

export default component.exports